<template>
	<div class="requirements-view">
		<div class="team" v-for="(team, j) in value" v-bind:key="j">
			<div class="title">Hold {{ team.id }}</div>
			<text-view v-model="team.desc" :label="false" padding="10px" style="margin-bottom: 10px;" />
			<div class="req" v-for="(req, i) in team.req" v-bind:key="i">
				<div class="title">{{ _roles[req.name] ? _roles[req.name].label : '' }}</div>
				<div class="props">
					<div v-for="(prop, name) in req.props" v-bind:key="name">
						{{ _roles[req.name]._props[name].label }}{{ prop.val ? ': ' + prop.val : '' }}
						<div class="buttons">
							<div class="orb" @click="decProp(j, i, name)">-</div>
							<div class="cnt">{{ prop.qty }}</div>
							<div class="orb" @click="incProp(j, i, name)">+</div>
							<div class="orb" @click="removeProp(j, i, name)">X</div>
						</div>
					</div>

					<div @click.stop="addProp($event, j, i)">Specificer</div>
				</div>
				<div class="buttons">
					<div class="orb" @click="dec(j, i)">-</div>
					<div class="cnt">{{ req.qty }}</div>
					<div class="orb" @click="inc(j, i)">+</div>
					<div class="orb" @click="remove(j, i)">X</div>
				</div>
			</div>
			<div class="buttons">
				<div @click="removeTeam(j)">Fjern</div>
			</div>
			<div class="btn" @click.stop="add($event, j)">Tilføj behov</div>
		</div>
		<div class="btn" @click.stop="addTeam">Tilføj hold</div>
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView'
	import merge from "../functions/merge";

	export default {
		data() {
			return {
				roles: [],
				teamIdxBuffer: null
			};
		},
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			}
		},
		computed: {
			_roles() {
				var r = {};

				for (var i = 0; i < this.roles.length; ++i) {
					r[this.roles[i].name] = this.roles[i];

					// Add props again
					r[this.roles[i].name]['_props'] = {};

					for (var j = 0; j < r[this.roles[i].name].props.length; ++j) {
						r[this.roles[i].name]._props[r[this.roles[i].name].props[j].name] = r[this.roles[i].name].props[j];
					}
				}

				return r;
			},
			_actions() {
				var r = [];
				var self = this;

				for (var i = 0; i < this.roles.length; ++i) {
					r.push({
						label: self.roles[i].label,
						action: (function () {
							var j = i;

							return function () {
								

								// Ignore if already on list
								if (self.value[self.teamIdxBuffer].req.find(function (item) { return item.name == self.roles[j].name; })) return;

								var value = merge(self.value, {});

								value[self.teamIdxBuffer].req.push({
									name: self.roles[j].name,
									props: {},
									id: null,
									qty: 1
								});

								self.$emit('input', value);
							}
						})()
					});
				}

				return r;
			}
		},
		methods: {
			add(event, teamIdx) {
				this.teamIdxBuffer = teamIdx;

				

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: this._actions
				});
			},
			remove(teamIdx, reqIdx) {
				//

				var value = Array.from(this.value);
				value[teamIdx].req.splice(reqIdx, 1)

				this.$emit('input', value);
			},
			inc(teamIdx, reqIdx) {
				var value = Array.from(this.value);
				value[teamIdx].req[reqIdx].qty++;

				this.$emit('input', value);
			},
			dec(teamIdx, reqIdx) {
				var value = Array.from(this.value);
				value[teamIdx].req[reqIdx].qty--;

				if (value[teamIdx].req[reqIdx].qty == 0) {
					this.remove(teamIdx, reqIdx);
					return;
				}

				this.$emit('input', value);
			},
			addProp(event, teamIdx, reqIdx) {
				
				

				var self = this;
				var actions = [];
				var props = this._roles[this.value[teamIdx].req[reqIdx].name].props;

				if (props.length > 1) {
					for (var i = 0; i < props.length; ++i) {
						actions.push({
							label: props[i].label,
							action: (function () {
								var j = i;

								return function () {
									var value = Array.from(self.value);

									if (Array.isArray(value[teamIdx].req[reqIdx].props)) {
										value[teamIdx].req[reqIdx].props = {};
									}

									if (props[j].type == 'StringView') {
										var val;
										if (!(val = prompt(props[j].label))) return;

										value[teamIdx].req[reqIdx].props[props[j].name] = {
											qty: 1,
											val: val
										};
									} else {
										value[teamIdx].req[reqIdx].props[props[j].name] = {
											qty: 1,
											val: null
										};
									}

									

									self.$emit('input', value);
								}
							})()
						});
					}

					//

					this.$store.state.popupController.toggle(ContextPopupView, {
						anchor: event.target,
						align: 'left',
						actions: actions
					});
				} else if (props.length == 1) {
					var j = 0;
					var value = Array.from(self.value);

					if (Array.isArray(value[teamIdx].req[reqIdx].props)) {
						value[teamIdx].req[reqIdx].props = {};
					}

					if (props[j].type == 'StringView') {
						var val;
						if (!(val = prompt(props[j].label))) return;

						value[teamIdx].req[reqIdx].props[props[j].name] = {
							qty: 1,
							val: val
						};
					} else {
						value[teamIdx].req[reqIdx].props[props[j].name] = {
							qty: 1,
							val: null
						};
					}

					

					self.$emit('input', value);
				}
			},
			incProp(j, i, name) {
				var value = Array.from(this.value);
				value[j].req[i].props[name].qty++;

				this.$emit('input', value);
			},
			decProp(j, i, name) {
				var value = Array.from(this.value);
				value[j].req[i].props[name].qty--;

				if (value[j].req[i].props[name].qty == 0) {
					this.removeProp(j, i, name);
					return;
				}

				this.$emit('input', value);
			},
			removeProp(j, i, name) {
				

				var value = Array.from(this.value);
				delete value[j].req[i].props[name];

				this.$emit('input', value);
			},
			addTeam() {
				this.$emit('input', this.value.concat({
					title: 'Hold ' /*+ (this.value.length + 1) */,
					desc: '',
					id: this.value.reduce(function (val, item) { return item.id >= val ? item.id + 1 : val; }, 1),
					req: []
				}));
			},
			removeTeam(idx) {
				

				var value = Array.from(this.value);
				value.splice(idx, 1)

				this.$emit('input', value);
			}
		},
		created() {
			

			var self = this;

			// Get employees
			this.axios
				.get('/us/employees/roles/')
				.then(function (r) {
					

					self.roles = self.roles.concat(r.data._items);
				});

			// Get vehicles
			this.axios
				.get('/us/vehicles/roles/')
				.then(function (r) {
					

					self.roles = self.roles.concat(r.data._items);
				});

			if (this.value.length == 0) {
				this.addTeam();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.requirements-view {
		& > .team {
			margin-bottom: 10px;
			border-bottom: 1px solid #2d2f36;
			position: relative;

			& > .title {
				padding-left: 10px;
				height: 30px;
				line-height: 30px;
				position: relative;
				font-size: 16px;
			}

			& > .req {
				position: relative;
				border: 1px solid #2d2f36;
				line-height: 40px;
				text-align: left;
				padding-left: 10px;
				margin-bottom: 10px;

				& > .props {
					position: relative;
					line-height: 12px;

					& > div {
						font-size: 12px;
						cursor: pointer;
						margin-bottom: 10px;
						position: relative;
					}
				}

				& > .buttons {
					position: absolute;
					top: 0;
					right: 0;

					& > div {
						display: inline-block;
						margin-right: 15px;
						font-size: 12px;
						cursor: pointer;
					}
				}
			}

			& > .buttons, & > .req > .buttons, & > .req > * > * > .buttons {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
					cursor: pointer;

					&.orb {
						background-color: #f7223f;
						height: 20px;
						width: 20px;
						text-align: center;
						line-height: 20px;
						border-radius: 50%;
					}

					&.cnt {
						width: 30px;
						text-align: center;
					}
				}
			}
		}

		& > .btn, & > .team > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>